import { render, staticRenderFns } from "./WelcomeMessageRemoved.vue?vue&type=template&id=b77ddaf6&scoped=true"
import script from "./WelcomeMessageRemoved.vue?vue&type=script&lang=js"
export * from "./WelcomeMessageRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ddaf6",
  null
  
)

export default component.exports